import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import SelectVirtualized from '../../../../../../../../../components/Select/Virtualized';

import { getSelectedValue } from './helper';

const CategoryAssign = ({ index, categoryLength, category, onChangeAssignCategory, toggleEdit }) => {
  const { categories } = useSelector((state) => state.services);

  const [selectedValue, setSelectedValue] = useState(null);
  const [selectOptions, setSelectOptions] = useState([]);

  useEffect(
    () => {
      const value = getSelectedValue(category, categories);
      setSelectedValue(value);

      if (onChangeAssignCategory) {
        if (value.value === -1) {
          setSelectOptions([
            value,
            ...categories.map((provider) => ({
              label: provider.title,
              value: provider.id,
            })),
          ]);
        } else {
          setSelectOptions(
            categories.map((provider) => ({
              label: provider.title,
              value: provider.id,
            })),
          );
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [category, categories],
  );

  const onSave = () => {
    onChangeAssignCategory(category.provider_category_id, selectedValue.value);
  };

  const onToggleMode = () => {
    if (category.isEdit) {
      onSave();
      toggleEdit(category.provider_category_id, false);
    } else {
      toggleEdit(category.provider_category_id, true);
    }
  };

  return (
    <div className="services-import__list-assign">
      {onChangeAssignCategory && <div className="services-import__list-assign-from">Assigned</div>}
      {!onChangeAssignCategory && category.category_title !== selectedValue?.label && (
        <div className="services-import__list-assign-from" style={{ color: '#d8d8d8' }}>
          {category.category_title}
        </div>
      )}
      <div className="services-import__list-assign-selected">
        {!onChangeAssignCategory && <div className="services-import__list-assign-to">{selectedValue?.label}</div>}
        {!category.isEdit && onChangeAssignCategory && <div className="services-import__list-assign-to">{selectedValue?.label}</div>}
        {category.isEdit && onChangeAssignCategory && (
          <SelectVirtualized
            components={{ IndicatorSeparator: null }}
            className="services-import__list-assign-selected-select"
            onChange={(value) => setSelectedValue(value)}
            noOptionsMessage={() => 'Not found categories'}
            hideSelectedOptions={false}
            menuPlacement={categoryLength > 5 ? index + 5 > categoryLength ? 'top' : 'bottom' : 'bottom'}
            controlStyles={{
              minHeight: '24px',
              height: '24px',
              width: '372px',
            }}
            dropdownIndicatorStyles={{
              padding: '0px',
              paddingRight: '6px',
            }}
            valueContainerStyles={{
              padding: '0px',
              paddingRight: '6px',
              paddingLeft: '6px',
            }}
            value={selectedValue}
            options={selectOptions}
            placeholder="Choose category"
            maxMenuHeight={220}
          />
        )}
        {toggleEdit && (
          <Button bsSize="xsmall" onClick={onToggleMode}>
            {category.isEdit ? 'Save' : 'Change'}
          </Button>
        )}
      </div>
    </div>
  );
};

CategoryAssign.propTypes = {
  categoryLength: PropTypes.number,
  index: PropTypes.number,
  category: PropTypes.object,
  onChangeAssignCategory: PropTypes.func,
  toggleEdit: PropTypes.func,
};

export default CategoryAssign;
